import { useState, useEffect, useRef } from 'react';

/**
 * Tracks last-refresh time and flags stale data.
 * Usage:
 *   const { isStale, lastUpdated, refresh } = useStaleWarning(data);
 */
function useStaleWarning(data, staleThresholdMs = 30000) {
  const [lastUpdated, setLastUpdated] = useState(null);
  const [isStale, setIsStale] = useState(false);
  const checkRef = useRef(null);

  useEffect(() => {
    if (data !== null && data !== undefined) {
      setLastUpdated(new Date());
      setIsStale(false);
    }
  }, [data]);

  useEffect(() => {
    if (lastUpdated) {
      if (checkRef.current) clearInterval(checkRef.current);
      checkRef.current = setInterval(() => {
        const age = Date.now() - lastUpdated.getTime();
        setIsStale(age >= staleThresholdMs);
      }, 5000);
    }
    return () => { clearInterval(checkRef.current); };
  }, [lastUpdated, staleThresholdMs]);

  const refresh = () => {
    setLastUpdated(new Date());
    setIsStale(false);
  };

  return { isStale, lastUpdated, refresh };
}

export default useStaleWarning;
